import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router";
import { Breadcrumbs, BreadcrumbType } from "src/components/Breadcrumb/Breadcrumbs";
import { useCatalogContext } from "./Summary/context/useCatalogContext";
import { Loading } from "src/components/utils/Loading";
import { Fragment } from "react/jsx-runtime";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { FoodsIcon } from "@foodpilot/foods";

export const TabHeaderCatalog = () => {
    const theme = useTheme();
    const { actionsByParents, areActionsReady } = useCatalogContext();

    if (areActionsReady === false) {
        return <Loading />;
    }

    const hasOnlyOneGroup = actionsByParents.catalogList.length === 1;
    return (
        <Stack flexDirection={"row"} gap={theme.spacing(2)}>
            {hasOnlyOneGroup ?
                <OneCategoryHeader />
            :   <MultipleCategoryHeader />}
        </Stack>
    );
};

const OneCategoryHeader = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    const { currentCatalog, currentAction } = useCatalogContext();
    const { urls } = useActionsContext();

    if (currentCatalog === undefined) {
        // Somethig is wrong
        return null;
    }

    const url = urls.catalog();
    return (
        <Stack gap={theme.spacing(0)}>
            {currentAction === undefined ?
                <Fragment>
                    <Typography variant="h2">{currentCatalog.parent.title}</Typography>
                </Fragment>
            :   <Fragment>
                    <Typography variant="h2">{currentAction.title}</Typography>
                    <Link to={url}>
                        <Box>
                            <Button variant="text" startIcon={<FoodsIcon size={2} icon={"arrowLeft"} />}>
                                {t("action_plan.back_to_catalog", "Go back to catalog")}
                            </Button>
                        </Box>
                    </Link>
                </Fragment>
            }
        </Stack>
    );
};

const MultipleCategoryHeader = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    const { urls } = useActionsContext();
    const { currentCatalog, currentAction } = useCatalogContext();
    const navigate = useNavigate();

    const breadcrumbs: BreadcrumbType[] = [];
    breadcrumbs.push({
        label: t("actions.catalog", "Action catalog"),
        action: () => {
            const url = urls.catalog();
            navigate(url);
        },
    });
    if (currentCatalog !== undefined) {
        breadcrumbs.push({
            label: currentCatalog.parent.title,
            action: () => {
                const url = urls.catalogGroup(currentCatalog.parent.id);
                navigate(url);
            },
        });
    }

    if (currentAction !== undefined) {
        breadcrumbs.push({
            label: currentAction.title,
        });
    }

    const lastItem = breadcrumbs.length - 1;
    const title = breadcrumbs[lastItem]?.label;

    return (
        <Stack gap={theme.spacing(1)}>
            <Typography variant="h2">{title}</Typography>
            {breadcrumbs.length > 1 && <Breadcrumbs items={breadcrumbs} />}
        </Stack>
    );
};
